import React from 'react'
import classes from './DashboardPatientRow.css'
import PatientInfo from '../../components/PatientInfo'

class DashboardPatientRow extends React.PureComponent {
  render() {
    const {
      participant: {
        connectionStatus,
        connectionTemplateID,
        customParticipantID,
        dob,
        fetching,
        firstName,
        id,
        lastName,
        orderingPhysician,
        prescribed,
      },
      navigateToPatient,
      openModal,
    } = this.props

    const { participant } = this.props

    return (
      <div className={classes.rowContainer}>
        <button
          className={classes.patientTile}
          onClick={() => navigateToPatient(id)}
        >
          <div className={classes.row}>
            <div className={classes.patientName}>
              {firstName} {lastName}
            </div>
          </div>

          <div className={classes.patientInfo}>
            <PatientInfo
              participant={participant}
            />
          </div>

        </button>
      </div>
    )
  }
}

export default DashboardPatientRow



// WEBPACK FOOTER //
// ./src/legacy/components/DashboardPatientRow/DashboardPatientRow.jsx